// extracted by mini-css-extract-plugin
export default {"wrap":"footer_wrap__FGhrd","main":"footer_main__qgGHg"};